import { Injectable, ElementRef } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { HelpInfoDialog } from "../_components/header/header.component";

const DEFAULT_WIDTH = "50vw";

function toPixelWidth(width: number | string): number {
  if (typeof width === "number") return width;
  const vwMatch = width.match(/^([\d.]+)vw$/);
  if (vwMatch) return Math.round((parseFloat(vwMatch[1]) / 100) * window.innerWidth);
  const pxMatch = width.match(/^([\d.]+)px$/);
  if (pxMatch) return parseFloat(pxMatch[1]);
  return 300;
}

@Injectable({ providedIn: "root" })
export class HelpInfoService {
  constructor(private dialog: MatDialog) {}

  open(
    evt: MouseEvent,
    index: number,
    config?: {
      width?: number | string;
      position?: { left?: string; top?: string };
      panelClass?: string;
      rightPosition?: boolean;
    },
  ): void {
    evt.stopPropagation();
    const target = new ElementRef(evt.currentTarget);
    const width = config?.width ?? DEFAULT_WIDTH;
    const cssWidth = typeof width === "number" ? `${width}px` : width;
    const dialogWidth = toPixelWidth(width);
    this.dialog.open(HelpInfoDialog, {
      width: cssWidth,
      ...(config?.position ? { position: config.position } : {}),
      ...(config?.panelClass ? { panelClass: config.panelClass } : {}),
      data: {
        trigger: target,
        helperIndex: index,
        dialogWidth,
        ...(config?.rightPosition ? { rightPosition: true } : {}),
      },
    });
  }
}
